<template>
  <div class="home-pc-index">
    <!-- 头部标题 -->
    <div class="header">
      <img src="./imgs/header-img-2.png" class="header-bg" style="margin-top: 10px" />
      <div class="header-content">
        <!-- <h1 class="title">朝阳区人事考试智能指挥调度一体化平台</h1> -->
        <div class="date" @click="goBack">{{ currentDate }}</div>
        <div class="exam-info">2025年度上半年事业单位公开招聘笔试</div>
      </div>
    </div>

    <!-- 左侧统计面板 - 引贤计划 -->
    <div class="left-panel">
      <div class="panel-section-title">
        <span class="section-icon"></span>
        <span>引贤计划(近三年数据分析)</span>
      </div>

      <!-- 报名人数 -->
      <div class="chart-section">
        <div class="section-label">
          <span class="label-dot blue"></span>
          <span>报名人数</span>
        </div>
        <div ref="chartYxBmr" class="chart-container-small"></div>
      </div>

      <!-- 审核通过人数 -->
      <div class="chart-section">
        <div class="section-label">
          <span class="label-dot cyan"></span>
          <span>审核通过人数</span>
        </div>
        <div ref="chartYxSh" class="chart-container-small"></div>
      </div>

      <!-- 笔试实考人数/实考率 -->
      <div class="chart-section">
        <div class="section-label">
          <span class="label-dot yellow"></span>
          <span>笔试实考人数/实考率</span>
        </div>
        <div ref="chartYxSk" class="chart-container-small"></div>
      </div>

      <!-- 岗位/实际岗位竞争比 -->
      <div class="chart-section">
        <div class="section-label">
          <span class="label-dot green"></span>
          <span>岗位/实际岗位竞争比</span>
        </div>
        <div ref="chartYxJz" class="chart-container-small"></div>
      </div>
    </div>

    <!-- 地图容器 -->
    <div id="mapContainer"></div>

    <!-- 右侧统计面板 - 社会公招 -->
    <div class="right-panel">
      <div class="panel-section-title">
        <span class="section-icon"></span>
        <span>社会公招(近三年数据分析)</span>
      </div>

      <!-- 报名人数 -->
      <div class="chart-section">
        <div class="section-label">
          <span class="label-dot blue"></span>
          <span>报名人数</span>
        </div>
        <div ref="chartShBmr" class="chart-container-small"></div>
      </div>

      <!-- 审核通过人数 -->
      <div class="chart-section">
        <div class="section-label">
          <span class="label-dot cyan"></span>
          <span>审核通过人数</span>
        </div>
        <div ref="chartShSh" class="chart-container-small"></div>
      </div>

      <!-- 笔试实考人数/实考率 -->
      <div class="chart-section">
        <div class="section-label">
          <span class="label-dot yellow"></span>
          <span>笔试实考人数/实考率</span>
        </div>
        <div ref="chartShSk" class="chart-container-small"></div>
      </div>

      <!-- 岗位/实际岗位竞争比 -->
      <div class="chart-section">
        <div class="section-label">
          <span class="label-dot green"></span>
          <span>岗位/实际岗位竞争比</span>
        </div>
        <div ref="chartShJz" class="chart-container-small"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentDate: '',
      MAP: null
    };
  },
  mounted() {
    this.setCurrentDate();
    this.mapInit();
    this.$nextTick(() => {
      setTimeout(() => {
        this.initCharts();
      }, 500);
    });
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    setCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      this.currentDate = `${year}-${month}-${day}`;
    },
    handleResize() {
      this.chartYxBmr && this.chartYxBmr.resize();
      this.chartYxSh && this.chartYxSh.resize();
      this.chartYxSk && this.chartYxSk.resize();
      this.chartYxJz && this.chartYxJz.resize();
      this.chartShBmr && this.chartShBmr.resize();
      this.chartShSh && this.chartShSh.resize();
      this.chartShSk && this.chartShSk.resize();
      this.chartShJz && this.chartShJz.resize();
    },
    mapInit() {
      let this_ = this;
      var options = {
        extensions: "all",
        level: "district"
      };
      var district = new AMap.DistrictSearch(options);
      district.search("朝阳区", function(status, result) {
        var bounds = result.districtList[0]["boundaries"];
        var map = new AMap.Map("mapContainer", {
          mapStyle: "amap://styles/darkblue",
          resizeEnable: true,
          zoom: 11.5,
          center: [116.525487, 39.930956],
          features: ["bg", "road", "building"]
        });
        for (var i = 0; i < bounds.length; i++) {
          new AMap.Polyline({
            path: bounds[i],
            strokeColor: "#00d4ff",
            strokeWeight: 2,
            map: map
          });
        }
        this_.MAP = map;
        this_.addMapMarkers(map);
      });
    },
    addMapMarkers(map) {
      const examPoints = [
        { name: "北京联合大学(北四环校区)", position: [116.515, 39.992], type: 1 },
        { name: "求实职业学校安贞里分校", position: [116.412, 39.972], type: 1 },
        { name: "北京联合大学师范学院", position: [116.418, 39.966], type: 1 },
        { name: "北京联合大学机器人学院", position: [116.435, 39.962], type: 1 },
        { name: "北京财贸职业学院(朝阳校区)", position: [116.448, 39.958], type: 1 },
        { name: "北京联合大学商务学院", position: [116.465, 39.945], type: 1 },
        { name: "北京市对外贸易学校", position: [116.572, 39.985], type: 2 },
        { name: "北京市求实职业学校(望京校区)", position: [116.478, 39.998], type: 2 },
        { name: "北京市陈经纶中学分校望京实验学校", position: [116.462, 39.985], type: 2 },
        { name: "北京中学二分校", position: [116.528, 39.935], type: 2 },
        { name: "劲松职业高中(常营校区)", position: [116.588, 39.925], type: 2 },
        { name: "电气工程学校管庄校区", position: [116.612, 39.905], type: 2 },
        { name: "北京联合大学生物化学工程学院(南区)", position: [116.552, 39.865], type: 2 }
      ];

      examPoints.forEach((point) => {
        const markerContent = `<div class="custom-marker type-${point.type}">
          <div class="marker-icon"></div>
          <div class="marker-label">${point.name}</div>
        </div>`;

        const marker = new AMap.Marker({
          position: point.position,
          content: markerContent,
          offset: new AMap.Pixel(-15, -30),
          map: map
        });
      });
    },
    initCharts() {
      const echarts = require('echarts');
      const commonGrid = { top: 25, left: 25, right: 10, bottom: 15, containLabel: true };
      const commonXAxis = {
        type: 'category',
        axisLine: { lineStyle: { color: '#3c6697' } },
        axisLabel: { color: '#fff', fontSize: 9 },
        axisTick: { show: false }
      };
      const commonYAxis = {
        type: 'value',
        axisLine: { show: false },
        splitLine: { lineStyle: { color: '#1a3a5c', type: 'dashed' } },
        axisLabel: { color: '#fff', fontSize: 9 }
      };

      // 引贤计划 - 报名人数
      this.chartYxBmr = echarts.init(this.$refs.chartYxBmr);
      this.chartYxBmr.setOption({
        grid: commonGrid,
        xAxis: { ...commonXAxis, data: ['2023\n上半年', '2024\n上半年', '2025\n上半年'] },
        yAxis: { ...commonYAxis, max: 8000 },
        series: [{
          data: [3614, 4323, 6223],
          type: 'bar',
          barWidth: '35%',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#00d4ff' },
              { offset: 1, color: '#0072ff' }
            ]),
            borderRadius: [3, 3, 0, 0]
          },
          label: { show: true, position: 'top', color: '#fff', fontSize: 10, fontWeight: 'bold' }
        }]
      });

      // 引贤计划 - 审核通过人数
      this.chartYxSh = echarts.init(this.$refs.chartYxSh);
      this.chartYxSh.setOption({
        grid: commonGrid,
        xAxis: { ...commonXAxis, data: ['2023\n上半年', '2024\n上半年', '2025\n上半年'] },
        yAxis: { ...commonYAxis, max: 10000 },
        series: [{
          data: [2759, 3620, 5298],
          type: 'bar',
          barWidth: '35%',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#00ffaa' },
              { offset: 1, color: '#00c6aa' }
            ]),
            borderRadius: [3, 3, 0, 0]
          },
          label: { show: true, position: 'top', color: '#fff', fontSize: 10, fontWeight: 'bold' }
        }]
      });

      // 引贤计划 - 笔试实考人数/实考率
      this.chartYxSk = echarts.init(this.$refs.chartYxSk);
      this.chartYxSk.setOption({
        grid: { top: 25, left: 25, right: 35, bottom: 15, containLabel: true },
        xAxis: { ...commonXAxis, data: ['2023\n上半年', '2024\n上半年'] },
        yAxis: [
          { ...commonYAxis, name: '', max: 5000 },
          { type: 'value', max: 100, axisLabel: { formatter: '{value}%', color: '#fff', fontSize: 9 }, splitLine: { show: false }, axisLine: { show: false } }
        ],
        series: [
          {
            name: '实考人数',
            data: [1265, 1992],
            type: 'bar',
            barWidth: '30%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#4488ff' },
                { offset: 1, color: '#2244aa' }
              ]),
              borderRadius: [3, 3, 0, 0]
            },
            label: { show: true, position: 'top', color: '#fff', fontSize: 10, fontWeight: 'bold' }
          },
          {
            name: '实考率',
            data: [45.8, 55],
            type: 'line',
            yAxisIndex: 1,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { color: '#ffaa00', width: 2 },
            itemStyle: { color: '#ffaa00' },
            label: { show: true, position: 'top', color: '#ffaa00', fontSize: 9, formatter: '{c}%' }
          }
        ]
      });

      // 引贤计划 - 岗位/实际岗位竞争比
      this.chartYxJz = echarts.init(this.$refs.chartYxJz);
      this.chartYxJz.setOption({
        grid: { top: 25, left: 25, right: 35, bottom: 15, containLabel: true },
        xAxis: { ...commonXAxis, data: ['2023\n上半年', '2024\n上半年'] },
        yAxis: [
          { ...commonYAxis, name: '', max: 120 },
          { type: 'value', max: 120, axisLabel: { color: '#fff', fontSize: 9 }, splitLine: { show: false }, axisLine: { show: false } }
        ],
        series: [
          {
            name: '岗位竞争比',
            data: [54.10, 55.69],
            type: 'bar',
            barWidth: '25%',
            itemStyle: { color: '#00d4ff', borderRadius: [2, 2, 0, 0] },
            label: { show: true, position: 'top', color: '#fff', fontSize: 9, fontWeight: 'bold' }
          },
          {
            name: '实际岗位竞争比',
            data: [24.80, 30.45],
            type: 'bar',
            barWidth: '25%',
            barGap: '20%',
            itemStyle: { color: '#00ff88', borderRadius: [2, 2, 0, 0] },
            label: { show: true, position: 'top', color: '#fff', fontSize: 9, fontWeight: 'bold' }
          }
        ]
      });

      // 社会公招 - 报名人数
      this.chartShBmr = echarts.init(this.$refs.chartShBmr);
      this.chartShBmr.setOption({
        grid: commonGrid,
        xAxis: { ...commonXAxis, data: ['2023\n上半年', '2023\n下半年', '2024\n上半年', '2024\n下半年', '2025\n上半年'] },
        yAxis: { ...commonYAxis, max: 15000 },
        series: [{
          data: [12170, 10283, 10863, 10237, 10047],
          type: 'bar',
          barWidth: '30%',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#00d4ff' },
              { offset: 1, color: '#0072ff' }
            ]),
            borderRadius: [3, 3, 0, 0]
          },
          label: { show: true, position: 'top', color: '#fff', fontSize: 9, fontWeight: 'bold' }
        }]
      });

      // 社会公招 - 审核通过人数
      this.chartShSh = echarts.init(this.$refs.chartShSh);
      this.chartShSh.setOption({
        grid: commonGrid,
        xAxis: { ...commonXAxis, data: ['2023\n上半年', '2023\n下半年', '2024\n上半年', '2024\n下半年', '2025\n上半年'] },
        yAxis: { ...commonYAxis, max: 15000 },
        series: [{
          data: [10823, 8767, 10019, 9371, 9238],
          type: 'bar',
          barWidth: '30%',
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#00ffaa' },
              { offset: 1, color: '#00c6aa' }
            ]),
            borderRadius: [3, 3, 0, 0]
          },
          label: { show: true, position: 'top', color: '#fff', fontSize: 9, fontWeight: 'bold' }
        }]
      });

      // 社会公招 - 笔试实考人数/实考率
      this.chartShSk = echarts.init(this.$refs.chartShSk);
      this.chartShSk.setOption({
        grid: { top: 25, left: 25, right: 35, bottom: 15, containLabel: true },
        xAxis: { ...commonXAxis, data: ['2023\n上半年', '2023\n下半年', '2024\n上半年', '2024\n下半年'] },
        yAxis: [
          { ...commonYAxis, name: '', max: 15000 },
          { type: 'value', max: 100, axisLabel: { formatter: '{value}%', color: '#fff', fontSize: 9 }, splitLine: { show: false }, axisLine: { show: false } }
        ],
        series: [
          {
            name: '实考人数',
            data: [6800, 5756, 6958, 6772],
            type: 'bar',
            barWidth: '30%',
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#4488ff' },
                { offset: 1, color: '#2244aa' }
              ]),
              borderRadius: [3, 3, 0, 0]
            },
            label: { show: true, position: 'top', color: '#fff', fontSize: 9, fontWeight: 'bold' }
          },
          {
            name: '实考率',
            data: [62.8, 65.7, 69.4, 72.3],
            type: 'line',
            yAxisIndex: 1,
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: { color: '#ffaa00', width: 2 },
            itemStyle: { color: '#ffaa00' },
            label: { show: true, position: 'top', color: '#ffaa00', fontSize: 9, formatter: '{c}%' }
          }
        ]
      });

      // 社会公招 - 岗位/实际岗位竞争比
      this.chartShJz = echarts.init(this.$refs.chartShJz);
      this.chartShJz.setOption({
        grid: { top: 25, left: 25, right: 35, bottom: 15, containLabel: true },
        xAxis: { ...commonXAxis, data: ['2023\n上半年', '2023\n下半年', '2024\n上半年', '2024\n下半年', '2025\n上半年'] },
        yAxis: [
          { ...commonYAxis, name: '', max: 150 },
          { type: 'value', max: 150, axisLabel: { color: '#fff', fontSize: 9 }, splitLine: { show: false }, axisLine: { show: false } }
        ],
        series: [
          {
            name: '岗位竞争比',
            data: [57.57, 53.79, 83.49, 74.97, 118.44],
            type: 'bar',
            barWidth: '25%',
            itemStyle: { color: '#00d4ff', borderRadius: [2, 2, 0, 0] },
            label: { show: true, position: 'top', color: '#fff', fontSize: 8, fontWeight: 'bold', rotate: 45 }
          },
          {
            name: '实际岗位竞争比',
            data: [36.17, 35.31, 57.98, 54.18, 85],
            type: 'bar',
            barWidth: '25%',
            barGap: '20%',
            itemStyle: { color: '#00ff88', borderRadius: [2, 2, 0, 0] },
            label: { show: true, position: 'top', color: '#fff', fontSize: 8, fontWeight: 'bold', rotate: 45 }
          }
        ]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.home-pc-index {
  width: 100vw;
  height: 100vh;
  color: #dbe2ff;
  background: #0a1628;
  overflow: hidden;
  position: relative;

  .header {
    width: 100%;
    height: 110px;
    position: absolute;
    left: 0px;
    top: 0;
    z-index: 10;

    .header-bg {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .header-content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      text-align: center;
      padding-top: 15px;

      .title {
        font-size: 28px;
        font-weight: bold;
        color: #fff;
        text-shadow: 0 0 20px #00d4ff;
        margin: 0;
        letter-spacing: 4px;
      }

      .date {
        position: absolute;
        left: 30px;
        top: 20px;
        font-size: 14px;
        color: #fff;
        cursor: pointer;
      }

      .exam-info {
        position: absolute;
        right: 30px;
        top: 20px;
        font-size: 14px;
        color: #fff;
        // padding: 5px 15px;
        // background: rgba(0, 212, 255, 0.1);
        // border: 1px solid rgba(0, 212, 255, 0.3);
        // border-radius: 4px;
      }
    }
  }

  #mapContainer {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
  }

  // 左侧面板
  .left-panel {
    position: absolute;
    left: 15px;
    top: 110px;
    width: 340px;
    bottom: 15px;
    z-index: 5;
    display: flex;
    flex-direction: column;
    background: rgba(6, 20, 40, 0.85);
    border: 1px solid rgba(0, 212, 255, 0.3);
    border-radius: 8px;
    padding: 12px;
    backdrop-filter: blur(10px);

    .panel-section-title {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      font-weight: bold;
      color: #fff;
      margin-bottom: 10px;
      padding-bottom: 8px;
      border-bottom: 2px solid rgba(0, 212, 255, 0.5);

      .section-icon {
        width: 4px;
        height: 16px;
        background: linear-gradient(to bottom, #00d4ff, #0072ff);
        border-radius: 2px;
      }
    }

    .chart-section {
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-bottom: 8px;
      min-height: 0;

      &:last-child {
        margin-bottom: 0;
      }

      .section-label {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: #fff;
        margin-bottom: 4px;

        .label-dot {
          width: 8px;
          height: 8px;
          border-radius: 2px;

          &.blue { background: #00d4ff; }
          &.cyan { background: #00ffaa; }
          &.yellow { background: #ffcc00; }
          &.green { background: #00ff88; }
        }
      }

      .chart-container-small {
        flex: 1;
        width: 100%;
        min-height: 0;
      }
    }
  }

  // 右侧面板
  .right-panel {
    position: absolute;
    right: 15px;
    top: 110px;
    width: 340px;
    bottom: 15px;
    z-index: 5;
    display: flex;
    flex-direction: column;
    background: rgba(6, 20, 40, 0.85);
    border: 1px solid rgba(0, 212, 255, 0.3);
    border-radius: 8px;
    padding: 12px;
    backdrop-filter: blur(10px);

    .panel-section-title {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 14px;
      font-weight: bold;
      color: #fff;
      margin-bottom: 10px;
      padding-bottom: 8px;
      border-bottom: 2px solid rgba(0, 212, 255, 0.5);

      .section-icon {
        width: 4px;
        height: 16px;
        background: linear-gradient(to bottom, #00d4ff, #0072ff);
        border-radius: 2px;
      }
    }

    .chart-section {
      flex: 1;
      display: flex;
      flex-direction: column;
      margin-bottom: 8px;
      min-height: 0;

      &:last-child {
        margin-bottom: 0;
      }

      .section-label {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        color: #fff;
        margin-bottom: 4px;

        .label-dot {
          width: 8px;
          height: 8px;
          border-radius: 2px;

          &.blue { background: #00d4ff; }
          &.cyan { background: #00ffaa; }
          &.yellow { background: #ffcc00; }
          &.green { background: #00ff88; }
        }
      }

      .chart-container-small {
        flex: 1;
        width: 100%;
        min-height: 0;
      }
    }
  }
}
</style>

<style>
.amap-logo {
  display: none !important;
}

/* 自定义地图标记样式 */
.custom-marker {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.custom-marker .marker-icon {
  width: 24px;
  height: 32px;
  background-size: contain;
  background-repeat: no-repeat;
}

.custom-marker.type-1 .marker-icon {
  background-image: url('./imgs/pointsIcon01.png');
}

.custom-marker.type-2 .marker-icon {
  background-image: url('./imgs/pointsIcon02.png');
}

.custom-marker.type-3 .marker-icon {
  background-image: url('./imgs/pointsIcon03.png');
}

.custom-marker .marker-label {
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  background: rgba(0, 20, 40, 0.9);
  color: #fff;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 11px;
  border: 1px solid rgba(0, 212, 255, 0.5);
  box-shadow: 0 0 10px rgba(0, 212, 255, 0.3);
}

.custom-marker.type-1 .marker-label {
  border-color: rgba(0, 255, 100, 0.6);
  background: rgba(0, 40, 20, 0.9);
}

.custom-marker.type-2 .marker-label {
  border-color: rgba(0, 200, 255, 0.6);
  background: rgba(0, 30, 50, 0.9);
}
</style>
